import {
  UCUidCacheKey,
  AuthIdCacheKey,
  ReportSDK,
  ReportDes,
  ProductId,
} from '@common/config';
import { getFromLocalStorage, getPageName } from '@common/util';
import { initAdsParams, getAdsExtendStr } from '@common/adsExtend';
import AppChannel from './channel';
initAdsParams();

const { pathname } = window.location;

// window.century_setting = {
//   product_id: ProductId,
//   os_type: 1,
//   web_version: 'v1.0.0',
//   pid: AppChannel,
//   uid: getFromLocalStorage(UCUidCacheKey),
//   business_uid: getFromLocalStorage(AuthIdCacheKey),
//   page_name: getPageName(pathname),
//   no_sysinfo: true,
//   sdk_js_domain: ReportSDK,
//   sdk_drm_domain: ReportDes,
//   ads_extend: getAdsExtendStr(),
// };
// const script = document.createElement('script');
// script.setAttribute('type', 'text/javascript');
// script.setAttribute('src', ReportSDK);
// script.onload = () => {
//   window?.ST?.webTJ?.getUuid(uuid => {
//     localStorage.setItem('_uuid', uuid);
//   });
// };
// document.body.appendChild(script);
